import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Nav,
  Navbar,
  Offcanvas,
  Dropdown,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Images from "./images";
import { Link } from "react-scroll";
import { sociallistApi } from "./API/cms.api";
import config from "./config";
import NavDropdown from "react-bootstrap/NavDropdown";
import { HashLink } from "react-router-hash-link";
import Playgalfimodal from "./Components/playgalfimodal";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [social, SetSocial] = useState(null);
  const [openPlayGalfi, setOpenPlayGalfi] = useState(false);
  const [openDiscardFrame, setOpenDiscardFrame] = useState(false)

  const toggleMenu = () => {
    const getWindowWidth = window.innerWidth;
    console.log("windn", getWindowWidth, menuOpen);
    if (getWindowWidth < 992) {
      setMenuOpen(false);
    } else {
      setMenuOpen(false);
    }
  };

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    fetchSocial();
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const fetchSocial = async () => {
    const socail = await sociallistApi();
    console.log("🚀 ~ fetchSocial ~ socail:", socail);
    if (socail.status) SetSocial(socail.data);
  };

  return (
    <>
      {openPlayGalfi && <Playgalfimodal onDismiss={() => setOpenPlayGalfi(false)} />}
      <div className={scrolled ? "header scrolled" : "header"}>
        <Navbar key="xl" expand="xl">
          <Container className="custom_contain head_contain px-xl-1 px-xxl-0">
            <Navbar.Brand>
              <HashLink to="/">
                <img
                  src={Images.logo}
                  className="img-fluid logo"
                  width={"100px"}
                  height={"100px"}
                  alt="images"
                />{" "}
              </HashLink>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={`offcanvasNavbar-expand-lg`}
              onClick={() => setMenuOpen(!menuOpen)}
            />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-xl`}
              aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
              placement="end"
              restoreFocus={false}
              show={menuOpen}
              onHide={() => setMenuOpen(!menuOpen)}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-xl`}>
                  <HashLink to="/" onClick={() => toggleMenu()}>
                    <img
                      src={Images.logo}
                      className="img-fluid smalllogo"
                      width="160px"
                      height="48px"
                      alt="images"
                    />
                  </HashLink>{" "}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <div className="d-flex flex-column flex-xl-row align-items-center justify-content-center justify-content-xl-between">
                <Offcanvas.Body>
                  <Nav className="align-items-center heading m_top">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex flex-column flex-xl-row align-items-center">
                        <HashLink
                          // to="/#playgalfi"
                          smooth={true}
                          duration={500}
                          activeClass="active"
                          spy={true}
                          activeClassName="active"
                          // onClick={() => toggleMenu()}
                          onClick={() => setOpenPlayGalfi(true)}
                        >
                          {" "}
                          Play GalFi
                        </HashLink>
                        <Dropdown className="text-center text-xl-start mobdrops">
                          <Dropdown.Toggle
                            className="btn_toggle"
                            variant="success"
                            id="dropdown-basic"
                          >
                            Docs
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="drop1">
                            {/* <Dropdown.Item as={HashLink} to="/#aboutgalfi">
                              {console.log("Socialszzz", social)}
                              About
                            </Dropdown.Item>
                            <Dropdown.Item as={HashLink} to="/#gallery">
                              {console.log("Socialszzz", social)}
                              Gallery
                            </Dropdown.Item>
                            <Dropdown.Item as={HashLink} to="/#blog">
                              {console.log("Socialszzz", social)}
                              Blog
                            </Dropdown.Item>
                            <Dropdown.Item as={HashLink} to="/#roadmaps">
                              {console.log("Socialszzz", social)}
                              Roadmap
                            </Dropdown.Item>
                            <Dropdown.Item as={HashLink} to="/#team">
                              {console.log("Socialszzz", social)}
                              Team
                            </Dropdown.Item>
                            <Dropdown.Item as={HashLink} to="/#builton">
                              {console.log("Socialszzz", social)}
                              Built On
                            </Dropdown.Item> */}
                            <Dropdown.Item href={`https://drive.google.com/file/d/1VaY4iR-PIUbUHJYgDT3VpZC46ZRNFQ9W/view`} target="_blank">
                              Whitepaper V2.0
                            </Dropdown.Item>
                            <Dropdown.Item href={`#`} target="_blank">
                              Pitch Deck
                            </Dropdown.Item>

                          </Dropdown.Menu>
                        </Dropdown>
                        {/* <HashLink
                    to="/#aboutgalfi"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    About
                  </HashLink> */}
                        {/* <Link to="section3" smooth={true} duration={500} activeClass="active" spy={true} activeClassName="active" onClick={() => toggleMenu()}> Whitepaper</Link> */}
                        {/* <a  href={`${config.CDN}galfiwhitepaper.pdf`}  target="_blank" onClick={() => toggleMenu()}>Whitepaper</a> */}
                        {/* <NavDropdown title="Whitepaper" id="collapsible-nav-dropdown">
                                        <NavDropdown.Item  href={`https://drive.google.com/file/d/1Pp-9ekAPAIPT_QhGkyg3iQKSFRxMmFNX/view`} target="_blank">PDF</NavDropdown.Item>
                                        <NavDropdown.Item href={social?.gitbook} target="_blank">
                                        GitBook
                                        </NavDropdown.Item>
                                      
                                    </NavDropdown> */}

                        {/* <Dropdown className="text-center text-xl-start mobdrops">
                          <Dropdown.Toggle className="btn_toggle" variant="success" id="dropdown-basic">
                            Whitepaper
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="drop1" >
                            <Dropdown.Item href={`https://drive.google.com/file/d/1VaY4iR-PIUbUHJYgDT3VpZC46ZRNFQ9W/view`} target="_blank">PDF</Dropdown.Item>
                            <Dropdown.Item href={social?.gitbook} target="_blank">GitBook</Dropdown.Item>
                                            <Dropdown.Item href="#" target="_blank">2-pager</Dropdown.Item>
                            <Dropdown.Item href="#" target="_blank">
                              Pitch Deck
                            </Dropdown.Item>
                            <Dropdown.Item href="#" target="_blank">Investor Deck</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                        {/* <HashLink to="/#lore" smooth={true} duration={500} activeClass="active" spy={true} activeClassName="active" onClick={() => toggleMenu()}> Lore</HashLink> */}
                        {/* <HashLink
                    to="/#gallery"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    Gallery
                  </HashLink> */}
                        {/* <Link to="section6" smooth={true} duration={500} activeClass="active" spy={true} activeClassName="active" onClick={() => toggleMenu()}> Socials</Link> */}
                        {/* <NavDropdown title="Socials" id="collapsible-nav-dropdown">
                                        <NavDropdown.Item  href={social?.discord} target="_blank" ><img src={Images.discard} className="me-1" /> Discord</NavDropdown.Item>
                                        <NavDropdown.Item href={social?.telegram} target="_blank">
                                        <img src={Images.tele} className="me-1" />
                                        Telegram
                                        </NavDropdown.Item>
                                        <NavDropdown.Item  href={social?.twitter} target="_blank" > <img src={Images.twit} className="me-1" /> Twitter</NavDropdown.Item>
                                        <NavDropdown.Item  href={social?.medium} target="_blank" ><img src={Images.dot} className="me-1" /> Medium</NavDropdown.Item>                                     
                                    </NavDropdown> */}
                        {/* <Dropdown className="text-center text-xl-start mobdrops">
                          <Dropdown.Toggle
                            className="btn_toggle"
                            variant="success"
                            id="dropdown-basic"
                          >
                            Socials
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="drop1">
                            <Dropdown.Item href={social?.discord} target="_blank">
                              {console.log("Socialszzz", social)}
                              <img src={Images.discard} className="me-1" /> Discord
                            </Dropdown.Item>
                            <Dropdown.Item href={social?.telegram} target="_blank">
                              <img src={Images.tele} className="me-1" />
                              Telegram
                            </Dropdown.Item>
                            <Dropdown.Item href={social?.twitter} target="_blank">
                              <img src={Images.twit} className="me-1" /> Twitter
                            </Dropdown.Item>

                            <Dropdown.Item href={social?.medium} target="_blank">
                              <img src={Images.dot} className="me-1" /> Medium
                            </Dropdown.Item>

                            <Dropdown.Item
                              href="https://www.youtube.com/watch?v=f7xSCWQ6Uck"
                              target="_blank"
                            >
                              <img src={Images.youtubes} className="me-1" /> Youtube
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                        {/* <a href={social?.medium} target="_blank" onClick={() => toggleMenu()}> Blog</a> */}
                        {/* <HashLink
                    to="/#blog"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    Blog
                  </HashLink> */}

                        {/* <Link to="section7" smooth={true} duration={500} activeClass="active" spy={true} activeClassName="active" onClick={() => toggleMenu()}> Blog</Link> */}
                        {/* <HashLink to="/#media" smooth={true} duration={500} activeClass="active" spy={true} activeClassName="active" onClick={() => toggleMenu()}> Media</HashLink> */}
                        {/* <HashLink
                    to="/#roadmaps"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    Roadmap
                  </HashLink> */}
                        {/* <HashLink
                    to="/#team"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    Team
                  </HashLink>
                  <HashLink
                    to="/#builton"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    activeClassName="active"
                    onClick={() => toggleMenu()}
                  >
                    {" "}
                    Built On
                  </HashLink> */}
                      </div>
                    </div>
                  </Nav>

                </Offcanvas.Body>
                <div className="d-flex flex-wrap align-items-center justify-content-center gap-4">
                  <a href="https://x.com/GalFiofficial"
                    target="_blank"
                    aria-label="socialtwitter"
                  >
                    <img src={Images.social5} className="img-fluid twiticon socialicon" width="130px" height="40px" alt="twitter" />
                  </a>
                  {/* <a
                    href="https://discord.com/invite/7HDCQssqv9"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn viewmore joindiscord"
                  >
                    Join Discord
                  </a> */}
                  <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); setOpenDiscardFrame(true) }}
                    rel="noopener noreferrer"
                    class="btn viewmore squareBorder"
                  >
                    Join Discord
                  </a>
                  {openDiscardFrame && (
                    <div
                     className="discardIframeContainer"
                      // style={{
                      //   position: 'fixed', top: 0, left: 0,
                      //   width: '100vw', height: '100vh',
                      //   backgroundColor: 'rgba(0,0,0,0.6)',
                      //   display: 'flex', alignItems: 'center', justifyContent: 'center',
                      //   zIndex: 9999,
                      // }}
                      onClick={() => setOpenDiscardFrame(false)}  
                    >
                      <div onClick={(e) => e.stopPropagation()}>  
                        <iframe
                          src="https://discord.com/widget?id=1247238608075751515&theme=dark"
                         
                          className="discordIfram"
                          allowTransparency="true"
                          frameBorder="0"
                          sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      </div>
    </>
  );
}

export default Header;
